import {
  DeactivateVehicleReasonInput,
  TVehicleTemplateType,
  TVehicleTemplateTypeInput,
  VehicleStatus
} from 'gql/generated/graphql'
import { GTVehicleDocumentCategoryInput, GTVehicleRegistrationCategoryInput } from 'gql/types.generated'
import { IDocument } from 'utils/file'

export interface ILicensePlateFormValues {
  type: EVehiclePlateType | ''
  number: string
  state?: {
    name: string
    code: string
  } | null
}
export interface ILicensePlatesFormValues {
  licensePlates: ILicensePlateFormValues[]
}

export interface IOdometerFormValues {
  odometerReading?: number | null
}

export interface IVehicleFeaturesFormValues {
  features: {
    brandCoverage?: EBrandCoverage | null
    amenities: string[]
    make?: string | null
    model?: string | null
    year?: number | null
  }
}

export interface IVehicleCardsFormValues {
  fuelCards: string[]
  tagCards: string[]
}

export interface ITemplateFormValues {
  template: {
    id: string
    type: TVehicleTemplateType | ''
    capacity: number | ''
  }
}

export interface IPartnerSettingsFormValues {
  externalID?: string | null
  partner: {
    name: string
    id: string
  }
  drivers: {
    id: string
    name: string
  }[]
}

export interface IVehicleDetailsFormValues {
  companies: {
    id: string
    name: string
  }[]
  name: string
  vin: string
  cityName?: string | null
  state?: {
    name: string
    code: string
  } | null
}

export interface IVehiclesV2FormStep1Values
  extends IPartnerSettingsFormValues,
    IVehicleDetailsFormValues,
    ITemplateFormValues,
    IVehicleCardsFormValues {}

export interface IVehiclesV2FormStep2Values
  extends IVehicleFeaturesFormValues,
    IOdometerFormValues,
    ILicensePlatesFormValues {}

export interface IVehicleRegistrationFormValues {
  registration: {
    isPermanent?: boolean
    expirationDate?: Date | ''
    state?: {
      name: string
      code: string
    } | null
    category?: GTVehicleRegistrationCategoryInput | null
    document?: IDocument
  }
}
export interface IInsurancePolicyFormValues {
  insurancePolicy: {
    expirationDate: Date | ''
    document: IDocument
  }
}

export interface IVehiclesV2FormInsuranceStepValues
  extends IInsurancePolicyFormValues,
    IVehicleRegistrationFormValues {}

export interface IVehicleDocument extends IDocument {
  category: GTVehicleDocumentCategoryInput
}
export interface IVehiclesV2FormDocumentsStepValues {
  documents: IVehicleDocument[]
}
export interface IVehiclesV2FormValues
  extends IVehiclesV2FormStep1Values,
    IVehiclesV2FormStep2Values,
    IVehiclesV2FormInsuranceStepValues,
    IVehiclesV2FormDocumentsStepValues {}

export enum ENewVehicleV2Step {
  DETAILS = 1,
  FEATURES = 2,
  INSURANCE = 3,
  DOCUMENTS = 4
}

export enum EBrandCoverage {
  CompleteBranding = 'Complete Branding',
  MediumBranding = 'Medium Branding',
  MinimumBranding = 'Minimum Branding',
  WithoutBranding = 'Without Branding'
}

export enum EVehiclePlateType {
  EmployeeTransport = 'Transporte de personal',
  Test = 'Prueba',
  Pass = 'Permiso',
  PublicTransport = 'Transporte Publico',
  Federal = 'Federales',
  Other = 'Otras',
  Load = 'Carga',
  Local = 'Locales'
}

export interface IVehiclesFilters {
  vehicle: {
    id: string
    name: string
    externalID: string
  }
  driver: {
    id: string
    name: string
  }
  partner: {
    id: string
    name: string
  }
  externalId: string
  make: string
  plate: string
  isAssigned: boolean | null
  hasDriver: boolean | null
  status: VehicleStatus | null
  type: TVehicleTemplateTypeInput | null
  plateType: EVehiclePlateType | null
  registrationState: {
    code: string
    name: string
  } | null
  vin: string
}

export interface IChangeVehicleStatusForm {
  status: VehicleStatus | ''
  reason: DeactivateVehicleReasonInput | ''
  comments?: string
}
